<template>
    <v-container fluid>
        <v-alert :value="true" type="success" dismissible v-model="alertSuccess">
            {{ resultMessage }}
        </v-alert>
        <v-alert :value="true" type="error" dismissible v-model="alertError">
            {{ resultMessage }}
        </v-alert>
        <v-card>
            <v-toolbar class="elevation1">
                <v-toolbar-title>
                    {{ selectedStudentClass }} - Students
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    append-icon="search"
                    label="search"
                    flat
                    v-model="search"
                    solo
                    ></v-text-field>
            </v-toolbar>
        </v-card>
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="classid"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
        >
        <template slot="items" slot-scope="props">
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.firstName }}</td>
            <td>
                <v-tooltip bottom>
                    <v-btn slot="activator" fab v-bind:dark="!readonly" small color="red" outline v-bind:disabled="readonly"
                    @click.stop="loadDialog(props.item)"
                    v-bind:value="props.item.id"
                    >
                        <v-icon dark>delete</v-icon>
                    </v-btn>
                    <span>Remove Student from Class</span>
                </v-tooltip>
            </td>
        </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="40%">
            <v-card>
                <v-card-title>
                    Confirmation
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-layout row wrap>
                                This action will remove the student &nbsp; 
                                <b> {{ studentName }} </b>
                                &nbsp; from the class &nbsp;
                                <b>  {{ selectedStudentClass }}  &nbsp; </b> 
                                on period &nbsp; <b>{{ periodName }}</b>
                            </v-layout>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat @click.stop="unloadDialog()">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.stop="deleteSC()">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { getStudentClassesByPeriod, deleteStudentClass, getReportingPeriodStatus } from '../utils/effort-tracking-api'
    import { globalStore } from '../main'

    export default {
        data() {
            return {
                search: '',
                loading: false,
                headers: [
                    { text: 'Code', value: 'studentCode', sortable: true },
                    { text: 'Last Name', value: 'lastName', sortable: true },
                    { text: 'First Name', value: 'firstName', sortable: true },
                    { text: 'Actions', value: '', sortable: false }
                ],
                items: [],
                pagination: { sortBy: 'lastName', rowsPerPage: globalStore.defaultRowsPerPage },
                totalItems: 0,
                rowsPerPageItems: globalStore.rowsPerPageItems,
                dialog: false,
                alertSuccess: false,
                alertError: false,
                selectedStudentClass: '',
                delReportingPeriodClassId: 0,
                delStudentId: 0,
                studentName: '',
                resultMessage: '',
                periodName: '',
                classCode: '',
                readonly: false
            }
        },
        mounted() {
            this.setPeriodName();
            this.selectedStudentClass = this.$route.params.className;
            this.classCode = this.$route.params.classCode;
            this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true });
            this.disableActions();
        },
        watch: {
            search() {
                this.debouncedGetDataFromApi();
            },
            pagination() {
                console.log('Pagination: ');
                console.log(this.pagination);
                this.debouncedGetDataFromApi();
            },
            deep: true
        },
        methods: {
            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },
            getDataFromApi() {
                this.loading = true;
                var classId = this.$route.params.classId;
                console.log('Getting data... ' + classId);
                getStudentClassesByPeriod(classId, this.pagination, this.search)
                .then(data => {
                    console.log(data);
                    this.items = data.items;
                    this.totalItems = data.count;
                    this.loading = false;
                }).catch(ex => { 
                    console.log(ex)
                    this.loading = false;
                });
            },
            loadDialog(item) {
                console.log(item);
                this.alertSuccess = false;
                this.alertError = false;
                this.studentName = item.firstName + ' ' + item.lastName;

                // this.delClassId = item.classId;
                this.delStudentId = item.studentId;
                this.delReportingPeriodClassId = item.reportingPeriodClassId;
                this.dialog = true;
            },
            setPeriodName() {
                //var periodId = globalStore.selectedPeriod;
                var periodId = localStorage.getItem('period-selected');
                var period = this.$store.state.periods.filter(p => p.id == Number(periodId));
                this.periodName = ((period.length > 0) ? period[0].text : '');
            },
            unloadDialog() {
                this.dialog = false;
                this.selectedStudentClassId = 0;
                this.selectedStudentClass = '';
            },
            deleteSC() {
                this.dialog = false;
                deleteStudentClass(this.delReportingPeriodClassId, this.delStudentId)
                .then(result => {
                    console.log(result);
                    this.debouncedGetDataFromApi();
                }).catch(ex => { console.log(ex) });
            },
            disableActions() {       
                getReportingPeriodStatus().then(result => {  
                    console.log('Reporting period status: ');
                    console.log(result);
                    
                    this.readonly = !result.active || result.complete;
                    console.log('this.readonly: ');
                    console.log(this.readonly);
                }).catch(ex => console.log(ex));
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/StudentClasses.vue